export interface ICardItem {
  lable: string;
  value: string;
  [additionalProperties: string]: any;
}
export interface ICardDate {
  begin: ICardItem;
  end: ICardItem;
}

export interface ICardSelf {
  photo?: string;
  key?: any; //主键
  type?: string; //类型？
  item?: ICardItem; //类型
  itemDate?: ICardDate; //起始日期
  empList?: ICardItem[];
  itemList?: ICardItem[]; //项目列表
  applyDate?: ICardItem; //申请日期
  [additionalProperties: string]: any;
}

export interface ICardEmp {
  photo?: string;
  code?: string;
  name?: string;
  postion?: string;
  org?: string;
  mobile?: string;
  email?: string;
}

export interface ICardLimit {
  photo?: string;
  code?: string;
  name?: string;
  postion?: string;
  org?: string;
  mobile?: string;
  email?: string;
  residue?: number;
  limit: number;
  limitUse: number;
  lastLimit: number;
  lastLimitUse: number;
}
